import React, { Fragment } from 'react'

import RenewStripe from './RenewStripe'
import RenewNonStripe from './RenewNonStripe'
import { useActiveMembershipContext } from '../../ActiveMembershipStore'

const Renewing = ({ stripeApiKey }) => {
  const {
    membershipInfo: { subscriptionSource }
  } = useActiveMembershipContext()

  const RenderRenewingBySource = () => {
    switch (subscriptionSource) {
      // If payment is flexsubscriptionSource will be 'stripe'
      case 'stripe': {
        return <RenewStripe stripeApiKey={stripeApiKey} />
      }
      case 'ios':
      case 'google': {
        return <RenewNonStripe source={subscriptionSource} />
      }
      default: {
        return null
      }
    }
  }

  return <Fragment>{RenderRenewingBySource()}</Fragment>
}

export default Renewing
